"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rep_common_1 = require("@sa/rep-common");
class ParameterBase {
    constructor(id, type, allowNullable, handleChange) {
        this._id = id;
        this._dataType = type;
        this._allowNullable = allowNullable;
        this._onPropertyChange = handleChange;
    }
    get id() {
        return this._id;
    }
    get dataType() {
        return this._dataType;
    }
    get allowNullable() {
        return this._allowNullable;
    }
    _isValueValid(value) {
        let isValid = false;
        switch (this._dataType) {
            case rep_common_1.DataType.Text:
                isValid = typeof value == "string";
                break;
            case rep_common_1.DataType.Number:
            case rep_common_1.DataType.Integer:
            case rep_common_1.DataType.Single:
            case rep_common_1.DataType.Double:
            case rep_common_1.DataType.Decimal:
                isValid = typeof value == "number";
                break;
            case rep_common_1.DataType.DateTime:
            case rep_common_1.DataType.Time:
            case rep_common_1.DataType.Date:
                isValid = value instanceof Date;
                break;
            case rep_common_1.DataType.Boolean:
                isValid = typeof value == "boolean";
                break;
        }
        return isValid;
    }
}
exports.ParameterBase = ParameterBase;
//# sourceMappingURL=ParameterBase.js.map